var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 11,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.223 1.02a.667.667 0 0 0-.838-.838L1.131 3.136a.667.667 0 0 0-.269 1.107l6.3 6.3a.667.667 0 0 0 1.106-.27l2.955-9.254ZM4.448 5.942l-1.87-1.87L9.56 1.846 7.331 8.826l-1.94-1.94 2.08-2.081a.667.667 0 1 0-.942-.943l-2.081 2.08Z",
    clipRule: "evenodd"
  })));
};
export default SvgSend;